import { render, staticRenderFns } from "./PaymentKlarna.vue?vue&type=template&id=14a8a64a&scoped=true"
import script from "./PaymentKlarna.vue?vue&type=script&lang=js"
export * from "./PaymentKlarna.vue?vue&type=script&lang=js"
import style0 from "./PaymentKlarna.vue?vue&type=style&index=0&id=14a8a64a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a8a64a",
  null
  
)

export default component.exports